import React from 'react';
import AppBarComponent from '../../components/HeaderBar';
import ContentComponent from '../../components/Content';
import { Typography, Box, } from '@mui/material';
import { Link } from 'react-router-dom';

export default function MainScreen() {
    
  return (
    <> 
         <AppBarComponent />
         <Box sx={{height: 30}} />
            <Box sx={{display: 'flex', alignSelf: 'center', justifyContent: 'center', alignItems: 'center'}} >
                    <ContentComponent />
            </Box>
        
         
         <div className='wave'></div>
         <div className='wave'></div>
         <footer style={{marginBottom: 20}} >
            <Box sx={{padding: {xs: 5, sm: 5, md: 5, lg: 0, xl: 0}}} >
                 <Typography sx={{marginTop: 2, fontSize: {xs: 45, sm: 45, md: 20, lg: 20, xl: 20}, color: 'white'}} >LEGAL</Typography>
                 <Link to='/privacy' style={{ color: 'white', textTransform: 'capitalize', fontWeight: '300', opacity: '0.75', textDecoration: 'none', }} >
                    <Typography sx={{marginTop: 2, opacity: 0.65, fontSize: {xs: 40, sm: 40, md: 18, lg: 18, xl: 18},}}  >
                                Privacy Policy
                    </Typography>    
                 </Link>
            </Box>
           
         </footer>
    </>
  );
}
